import { render } from "./ScrollingIcons.vue?vue&type=template&id=0c383fd3&scoped=true"
import script from "./ScrollingIcons.vue?vue&type=script&lang=js"
export * from "./ScrollingIcons.vue?vue&type=script&lang=js"

import "./ScrollingIcons.vue?vue&type=style&index=0&id=0c383fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c383fd3"]])

export default __exports__